import React , {useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  AppBar,
  Box,
  Flag,
  Hidden,
  IconButton,
  Link,
  makeStyles,
  MenuItem,
  Select,
  SvgIcon,
  Typography,
  Toolbar,
  TextField
} from '@material-ui/core';
import { Menu as MenuIcon } from 'react-feather';
import Logo from 'src/components/Logo';
import Image from 'src/components/Image';
import NoticeBell from 'src/components/NoticeBell';
import { THEMES } from 'src/constants';
import Account from './Account';
import Contacts from './Contacts';
import Notifications from './Notifications';
import Search from './Search';
import Settings from './Settings';
import Nations from './Nations';
import useMenu from 'src/hooks/useMenu';
import { useDispatch, useSelector } from 'react-redux';
import { createConstructor, isConstructorDeclaration } from 'typescript';

const useStyles = makeStyles((theme) => ({
  root: {
    // zIndex: theme.zIndex.drawer + 100,
    // ...theme.name === THEMES.LIGHT ? {
    //   boxShadow: 'none',
    //   backgroundColor: theme.palette.background.default
    // } : {},
    // ...theme.name === THEMES.ONE_DARK ? {
    //   backgroundColor: theme.palette.background.default
    // } : {}
    backgroundColor: theme.palette.background.default,
  },
  toolbar: {
    minHeight: 64
  },
  title: {
    fontFamily: "Roboto",
    fontStyle:"normal",
    fontWeight: 700,
    fontSize: "24px",
    color: "rgba(24, 24, 25, 0.8)",
    lineHeight: "22.4px",
  },
  selectedMenu: {
    fontFamily: "Roboto",
    fontStyle:"normal",
    fontWeight: 700,
    fontSize: "16px",
    color: "rgba(24, 24, 25, 0.6)",
    lineHeight: "22.4px",
  }
}));

const TopBar = ({
  className,
  onMobileNavOpen,
  onToggleDrawer,
  ...rest
 
}) => {
  const classes = useStyles();
  const menu = useSelector((state) => state.menu.value)

  return (
    <AppBar
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Toolbar className={classes.toolbar}>
        <Hidden lgUp>
          <IconButton
            onClick={onMobileNavOpen}
          >
            <SvgIcon fontSize="small">
              <MenuIcon />
            </SvgIcon>
          </IconButton>

        </Hidden>
        <Box
          ml={2}
          flexGrow={1}
        />
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          {/* <Image folder="topbar" filename="Code_BI_horizontal" width="262px" height="64px"/> */}
          <Box>
          <Link
            color="inherit"
            component={RouterLink}
            to={`/`}
            variant="h6"
          >
            <Typography className={classes.title}>Oneword Admin</Typography>
          </Link>
          </Box>
        </Box>
        
        <Box
          ml={2}
          flexGrow={1}
        />
        {/* <Box mx={2}>
          <NoticeBell />
        </Box>
        <Box mx={1}>
          <Nations />
        </Box> */}
        <Box mx={1}>
          {/* <Account /> */}
        </Box>
      </Toolbar>
    </AppBar> 
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func
};

TopBar.defaultProps = {
  onMobileNavOpen: () => {}
};

export default TopBar;
